import React from 'react';
import { Scan, Sparkles, CheckSquare, Calculator, Settings } from 'lucide-react';
import { useAppStore } from '../store';
import { useTranslation } from '../utils/translations';

export default function TabNavigation() {
  const { t } = useTranslation();
  const { activeTab, setActiveTab, prices, selectedPair, setSelectedPair } = useAppStore();

  const tabs = [
    { id: 'scanner', label: t('scanner'), fullLabel: t('session_scanner'), icon: Scan },
    { id: 'ai-analysis', label: 'AI', fullLabel: 'AI Deep Analysis', icon: Sparkles },
    { id: 'checklist', label: t('checklist'), fullLabel: 'AI Checklist', icon: CheckSquare },
    { id: 'strategies', label: 'Strategies', fullLabel: 'Strategies / Checklist', icon: Settings },
    { id: 'calculator', label: 'Calculator', fullLabel: 'Lot Size Calculator', icon: Calculator },
  ];

  return (
    <div className="space-y-3">
      {/* Mobile Pair Selector */}
      <div className="lg:hidden flex gap-2 overflow-x-auto pb-2 -mx-3 px-3 scrollbar-hide">
        {prices.slice(0, 8).map((pair) => (
          <button
            key={pair.symbol}
            onClick={() => setSelectedPair(pair.symbol)}
            className={`flex-shrink-0 px-3.5 py-2 rounded-lg text-xs font-semibold transition-smooth active:scale-95 ${selectedPair === pair.symbol
              ? 'bg-gradient-to-r from-violet-500 to-violet-600 text-white shadow-soft shadow-violet-500/20 border border-violet-400/30'
              : 'bg-slate-800/50 text-slate-400 border border-slate-700/30 hover:bg-slate-800/70 hover:text-slate-200'
              }`}
          >
            {pair.symbol}
          </button>
        ))}
      </div>

      {/* Tab Buttons - Scrollable on mobile */}
      <div className="overflow-x-auto scrollbar-hide -mx-2 px-2">
        <div className="flex gap-1.5 sm:gap-2 min-w-max">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-1.5 sm:gap-2.5 px-3.5 sm:px-5 py-2.5 sm:py-3 rounded-lg sm:rounded-xl text-xs sm:text-sm font-semibold transition-smooth whitespace-nowrap active:scale-95 ${activeTab === tab.id
                  ? 'bg-gradient-to-r from-violet-500 to-violet-600 text-white shadow-medium shadow-violet-500/30 border border-violet-400/30'
                  : 'bg-slate-800/50 text-slate-400 hover:bg-slate-800/70 hover:text-slate-200 border border-slate-700/30 hover:border-slate-600/40'
                  }`}
              >
                <Icon className={`w-3.5 h-3.5 sm:w-4 sm:h-4 ${activeTab === tab.id ? 'text-white' : 'text-slate-400'}`} />
                <span className="sm:hidden">{tab.label}</span>
                <span className="hidden sm:inline tracking-tight">{tab.fullLabel}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
